export const WHATSAPP_PHONE = '5511959034861'

export const DEFAULT_WHATSAPP_MESSAGE = 'Olá! Gostaria de solicitar um orçamento.'

export const MIN_ORDER_PIECES = 20

export function buildWhatsAppUrl(message: string) {
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`
}
